import { FORM_ADAPTER_TYPES, useFormAdapter } from '@eti/providers';
import { ReduxField } from './ReduxAdaptedField';
import { RHFField } from './RHFAdaptedField';
import { jsx as _jsx } from "react/jsx-runtime";
const Field = ({
  component: Component,
  format,
  name,
  normalize,
  onBlur,
  onChange,
  onFocus,
  props: fieldProps,
  useRHF = true,
  validate,
  warn,
  ...restProps
}) => {
  const ctx = useFormAdapter();
  const mergedProps = {
    ...restProps,
    ...fieldProps
  };
  if (!ctx) {
    throw new Error(`Field component must be used within <FormAdapterProvider>.`);
  }
  if (ctx.type === FORM_ADAPTER_TYPES.REDUX || !useRHF) {
    return /*#__PURE__*/_jsx(ReduxField, {
      component: Component,
      format: format,
      name: name,
      normalize: normalize,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      props: mergedProps,
      validate: validate,
      warn: warn
    });
  }
  return /*#__PURE__*/_jsx(RHFField, {
    component: Component,
    format: format,
    name: name,
    normalize: normalize,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    props: mergedProps,
    validate: validate,
    warn: warn
  });
};
export default Field;
//# sourceMappingURL=AdaptedField.js.map